import { render, staticRenderFns } from "./ModifybinPepscore.vue?vue&type=template&id=680fdb85&"
import script from "./ModifybinPepscore.vue?vue&type=script&lang=js&"
export * from "./ModifybinPepscore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports